import { IIssueBoardApi } from "@schemas/issueBoardSchema";
import React from "react";
import { FailedAlert } from "../../../../components";
import { useUpdateIssueBoardDisabledColumnsMutation } from "../IssueBoardRTK";
import { ISSUE_DATAFILEDS_ENUM } from "../issueConstants";
import { getIssueActionNameOption } from "../issueUtils";
import DisabledIssueColumns from "./DisableIssueColumns";
import SettingsCardWrapper from "./SettingsCardWrapper";

const IssueColumnSettingsTasks: React.FC<{ issueBoard: IIssueBoardApi }> = ({ issueBoard }) => {
  const [updateBoards, { isLoading: updateBoardsLoading, error: updateBoardsError }] =
    useUpdateIssueBoardDisabledColumnsMutation();

  const [editMode, setEditMode] = React.useState(false);

  const baseColumns: ISSUE_DATAFILEDS_ENUM[] = [
    ISSUE_DATAFILEDS_ENUM.ASSIGNEDTO_NAME,
    ISSUE_DATAFILEDS_ENUM.STATUS,
    ISSUE_DATAFILEDS_ENUM.DATES_DUE,
    ISSUE_DATAFILEDS_ENUM.DATES_COMPLETED,
  ];

  const customAttributeFields = Object.values(issueBoard?.otherAttributesTasksConfig ?? {})
    .map((attr) => attr.label)
    .filter(Boolean);

  const columnsTobeDisabled = [...baseColumns, ...customAttributeFields];

  return (
    <SettingsCardWrapper
      title={`Deaktiverte kolonner for ${getIssueActionNameOption(
        issueBoard?.taskNameSetting,
        "plural",
      ).toLocaleLowerCase()} i tabellvisning`}
    >
      {updateBoardsError != null && <FailedAlert />}
      <DisabledIssueColumns
        updateBoards={(disabledColumnsTasks) =>
          updateBoards({
            body: {
              disabledColumns: disabledColumnsTasks,
              taskOrIssue: "TASK",
            },
            params: {
              projectId: issueBoard.project,
              issueBoardId: issueBoard._id,
            },
          })
        }
        board={issueBoard}
        isEditable
        editMode={editMode}
        editCb={(bool) => setEditMode(bool)}
        columnsTobeDisabled={columnsTobeDisabled}
        taskOrIssue="TASK"
      />
    </SettingsCardWrapper>
  );
};

export default IssueColumnSettingsTasks;
